/**
 * Página de Tareas — vista ASEADOR.
 *
 * Reusa el componente `TareasCliente` con `mode="aseador"`. La UX y los
 * filtros son idénticos al cliente; lo que cambia es el copy del header,
 * la etiqueta "Asignada a mí" para distinguir las dos clases de tarea, y
 * sobre todo qué tareas devuelve el backend:
 *
 *  1) Tareas con `trabajador_id === user.id` (asignadas por nombre).
 *  2) Tareas de propiedades donde el aseador tiene aseo hoy o futuro
 *     (`Cleaning.id_usuario === user.id` con `fecha_inicio >= hoy` y
 *     `estado` ∈ `pendiente|en_proceso`).
 *
 * El filtro corre en `tasks.controller.js` (`listTasks` + `getDb`). Ver
 * `docs/rol-aseador.md` §5bis "Tareas".
 */

import TareasCliente from "./tareasCliente";

export default function TareasAseador() {
  return <TareasCliente mode="aseador" />;
}
